import {tempo} from '@tempo/core';

export const LicenseCardRoot = tempo('div', {
	baseStyle: ({theme}) => ({
		border: `1px solid ${theme.colors.neutral[500]}`,
		borderRadius: '4px',
		padding: 6,
		margin: `${theme.space[6]} 0`,
	}),
});

export const LicenseCardTitle = tempo('h2', {
	baseStyle: {
		color: 'text.accent.primary.default',
		fontSize: '2xl',
		fontWeight: 'bold',
		marginBottom: 4,
	},
});

export const LicenseCardSubtitle = tempo('h3', {
	baseStyle: ({theme}) => ({
		borderBottom: `1px solid ${theme.colors.neutral[500]}`,
		fontSize: 'xl',
		fontWeight: 'bold',
		marginBottom: 4,
	}),
});

export const LicenseCardLink = tempo('a', {
	baseStyle: {
		color: 'text.accent.primary.hovered',
		textDecoration: 'underline',
	},
});

export const LicenseCardContent = tempo('div', {
	baseStyle: ({theme}) => ({
		border: `1px solid ${theme.colors.neutral[500]}`,
		borderRadius: '4px',
		marginTop: 6,
		maxHeight: 'initial',
		overflow: 'hidden',
		position: 'relative',
	}),
});

export const LicenseCardText = tempo('pre', {
	baseStyle: {
		backgroundColor: 'background.neutral.secondary.default',
		fontSize: 'sm',
		margin: 0,
		padding: 3,
		whiteSpace: 'pre-wrap',
		wordBreak: 'break-word',
	},
});

export const LicenseCardToggle = tempo('div', {
	baseStyle: {
		position: 'absolute',
		top: 3,
		right: 3,
	},
});
